import React, { FC, useContext } from "react";
import styled from 'styled-components';
import { Helmet } from "react-helmet";
import { useCampaigns } from "utils/apis";
import { AppContext } from 'context/AppContext';

import Banner from 'containers/Home/components/Banner';
import Download from 'components/Download';
import HomePageSkeleton from './components/HomePageSkeleton';

import HotCampaignList from "./components/HotCampaignList";

const Container = styled.div<{ removeTopPadding?: boolean }>`
  padding: 100px;

  @media only screen and (max-width: 1200px) {
    padding: 50px;
  }

  @media only screen and (max-width: 800px) {
    padding: 20px;
  }

  /* Remove top padding when banner is hidden */
  ${props => props.removeTopPadding && `
    @media only screen and (min-width: 801px) {
      padding-top: 0;
    }
    
    @media only screen and (max-width: 1200px) {
      padding-top: 0;
    }
    
    @media only screen and (max-width: 800px) {
      padding-top: 20px;
    }
  `}
`;

const BannerContainer = styled.div<{ hideOnLogin?: boolean }>`
  @media only screen and (max-width: 800px) {
    display: none;
  }
  
  /* Hide banner in web view when user is logged in */
  @media only screen and (min-width: 801px) {
    ${props => props.hideOnLogin && `
      display: none;
    `}
  }
`;


const Home: FC = () => {
  const { authentication } = useContext(AppContext);
  const { authKey } = authentication;

  const { data: hotCampaigns, isLoading: isHotCampaignsLoading } = useCampaigns(true)
  const { data: otherCampaigns, isLoading: isOtherCampaignsLoading } = useCampaigns(false)

  const first_campaign = hotCampaigns.length > 0 ? hotCampaigns[0] : {
    name: '',
    description: '',
    user: {
      first_name: '', last_name: ''
    }
  };

  // Show skeleton loading state if data is loading
  const isLoading = isHotCampaignsLoading || isOtherCampaignsLoading;
  const hasData = hotCampaigns.length > 0 || otherCampaigns.length > 0;
  
  if (isLoading && !hasData) {
    return <HomePageSkeleton showBanner={true} />;
  }

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Goodmates ${first_campaign?.name}`}</title>
        <meta name="description" content={first_campaign.description} />
        <meta name="author" content={`${first_campaign?.user?.first_name} ${first_campaign?.user?.last_name}`} />

        {/* <meta property="og:url" content="" /> */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={first_campaign.name} />
        <meta property="og:description" content={first_campaign.description} />
        <meta property="og:site_name" content="Goodmates" />
        <meta property="og:image" content={first_campaign?.user?.profile?.image_small_url} />
      </Helmet>

      <BannerContainer hideOnLogin={!!authKey}>
        {hotCampaigns.length > 0 && <Banner campaigns={hotCampaigns} />}
        {hotCampaigns.length === 0 && otherCampaigns.length > 0 && <Banner campaigns={otherCampaigns} />}
      </BannerContainer>
      <Container removeTopPadding={!!authKey}>

      <HotCampaignList hotCampaigns={hotCampaigns} otherCampaigns={otherCampaigns} />

      {!authKey && <Download />}
    </Container>
    </div>

  );
}

export default Home;
